// ✏️  Edita los textos entre comillas
// ➕  Para agregar un módulo de negocio propio de este repo:
//     1. Crea data/<modulo>.ts (copia inicio.ts como referencia de formato)
//        con el submenú de respuestas de ese módulo
//     2. Impórtalo y agrégalo a 'secciones' en chatbot-erp.data.ts
//     3. Agrega aquí abajo: { boton: '🛒 Comercial', llevaA: 'comercial' }
// 🔗  'llevaA' debe coincidir con el nombre que le pongas en 'secciones'
// ⚠️  No elimines llaves { }, corchetes [ ] ni comas ,

export const MODULOS = {
  mensaje: '¿Qué módulo necesitas encontrar?',
  opciones: [],
}
